// Generated by scripts/fonts/subset_fonts.py (`npm run fonts:subset`). Do not edit by hand:
// change the script and rerun it. See the script for when it needs rerunning.
//
// Every family below is one subset file per style, limited to a unicode-range that lists
// exactly the characters the file contains, so the browser only downloads a file when the
// page uses one of them. Only the core files are preloaded.
//
// Inter v20 is subset from Google Fonts' files in scripts/fonts/inter-v20 (they come from
// there rather than next/font/google, which intermittently fails builds when Google serves
// extensionless font URLs). The faces declare wght 400–600, so nothing renders bold Inter:
// a stray `font-bold` or `<strong>` (`bolder` → 700) clamps to semibold.
//
// Circular Std Black is the display face for headings and brand moments (`font-circular`).
// Only Black ships, so every weight resolves to it.

import localFont from "next/font/local"

const fontInterCyrillicExt = localFont({
  src: [
    { path: "../fonts/inter/inter-cyrillic-ext-normal.woff2", style: "normal" },
    { path: "../fonts/inter/inter-cyrillic-ext-italic.woff2", style: "italic" },
  ],
  weight: "400 600",
  display: "swap",
  preload: false,
  adjustFontFallback: false,
  declarations: [
    {
      prop: "unicode-range",
      value:
        "U+0460-0479, U+0480-048F, U+0492-049D, U+04A0-04AF, U+04B2-04FF, U+052F, U+20B4, U+2DFF, U+A69F",
    },
  ],
})

const fontInterCyrillic = localFont({
  src: [
    { path: "../fonts/inter/inter-cyrillic-normal.woff2", style: "normal" },
    { path: "../fonts/inter/inter-cyrillic-italic.woff2", style: "italic" },
  ],
  weight: "400 600",
  display: "swap",
  preload: false,
  adjustFontFallback: false,
  declarations: [
    {
      prop: "unicode-range",
      value: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116",
    },
  ],
})

const fontInterGreekExt = localFont({
  src: [
    { path: "../fonts/inter/inter-greek-ext-normal.woff2", style: "normal" },
    { path: "../fonts/inter/inter-greek-ext-italic.woff2", style: "italic" },
  ],
  weight: "400 600",
  display: "swap",
  preload: false,
  adjustFontFallback: false,
  declarations: [
    {
      prop: "unicode-range",
      value:
        "U+1F00-1F15, U+1F18-1F1D, U+1F20-1F45, U+1F48-1F4D, U+1F50-1F57, U+1F59, U+1F5B, U+1F5D, U+1F5F-1F7D, U+1F80-1FB4, U+1FB6-1FC4, U+1FC6-1FD3, U+1FD6-1FDB, U+1FDD-1FEF, U+1FF2-1FF4, U+1FF6-1FFE",
    },
  ],
})

const fontInterGreek = localFont({
  src: [
    { path: "../fonts/inter/inter-greek-normal.woff2", style: "normal" },
    { path: "../fonts/inter/inter-greek-italic.woff2", style: "italic" },
  ],
  weight: "400 600",
  display: "swap",
  preload: false,
  adjustFontFallback: false,
  declarations: [
    {
      prop: "unicode-range",
      value:
        "U+0374-0376, U+037A-037F, U+0384-038A, U+038C, U+038E-03A1, U+03A3-03D7, U+03DC-03DD, U+03F0-03F6, U+03F9-03FA, U+03FC-03FF",
    },
  ],
})

const fontInterVietnamese = localFont({
  src: [
    { path: "../fonts/inter/inter-vietnamese-normal.woff2", style: "normal" },
    { path: "../fonts/inter/inter-vietnamese-italic.woff2", style: "italic" },
  ],
  weight: "400 600",
  display: "swap",
  preload: false,
  adjustFontFallback: false,
  declarations: [
    {
      prop: "unicode-range",
      value:
        "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+1EA0-1EF9, U+20AB",
    },
  ],
})

const fontInterLatinExtRare = localFont({
  src: [
    {
      path: "../fonts/inter/inter-latin-ext-rare-normal.woff2",
      style: "normal",
    },
    {
      path: "../fonts/inter/inter-latin-ext-rare-italic.woff2",
      style: "italic",
    },
  ],
  weight: "400 600",
  display: "swap",
  preload: false,
  adjustFontFallback: false,
  declarations: [
    {
      prop: "unicode-range",
      value:
        "U+0182, U+0184-0185, U+018D, U+018F-0190, U+019C, U+01A2-01A3, U+01A6, U+01A9-01AA, U+01B1-01B2, U+01B8, U+01BA-01C3, U+01C7, U+01CA, U+01EE, U+01F7, U+021C-021D, U+0220, U+0222-0223, U+0238-0239, U+0241-0242, U+0245, U+0251-0252, U+0254, U+0258, U+0261-0262, U+0264, U+0269-026A, U+0274, U+0277-0278, U+027A, U+0280-0281, U+0284, U+0286, U+028A-028B, U+028D, U+0293-0299, U+029B, U+029F, U+02A1-02A2, U+02A7, U+02AB-02AD, U+02B0-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D1, U+02D4-02D7, U+02DD-02ED, U+02EF-02FF, U+0304, U+0308, U+1D0D, U+1D43, U+1D47-1D49, U+1D4D, U+1D4F-1D50, U+1D52, U+1D56-1D58, U+1D5B, U+1D9C, U+1DA0, U+1DBB, U+1DBF, U+1E9D, U+1E9F, U+1EFA-1EFF, U+20A0, U+20A2-20A6, U+20AA, U+20AD-20AE, U+20B1, U+20B3, U+20B9-20BA, U+20BC-20BE, U+2113, U+A7FF",
    },
  ],
})

const fontInterLatinExt = localFont({
  src: [
    { path: "../fonts/inter/inter-latin-ext-normal.woff2", style: "normal" },
    { path: "../fonts/inter/inter-latin-ext-italic.woff2", style: "italic" },
  ],
  weight: "400 600",
  display: "swap",
  preload: false,
  adjustFontFallback: false,
  declarations: [
    {
      prop: "unicode-range",
      value:
        "U+0100-0101, U+0104-010F, U+0112-0127, U+012A-0130, U+0132-0148, U+014A-0151, U+0154-0167, U+016A-0181, U+0183, U+0186-018C, U+018E, U+0191-019B, U+019D-019F, U+01A4-01A5, U+01A7-01A8, U+01AB-01AE, U+01B3-01B7, U+01B9, U+01C5-01C6, U+01C8-01C9, U+01CB-01ED, U+01EF-01F6, U+01F8-021B, U+021E-021F, U+0221, U+0224-0237, U+023A-0240, U+0243-0244, U+0246-0250, U+0253, U+0256-0257, U+0259-0260, U+0263, U+0265-0268, U+026B-0273, U+0275-0276, U+0279, U+027B, U+027E-027F, U+0282-0283, U+0287-0289, U+028C, U+028E-0290, U+0292, U+029A, U+029C-029E, U+02A0, U+02A3-02A4, U+02A6, U+02A8-02AA, U+02AE-02AF, U+02D2-02D3, U+02EE, U+0304, U+0308, U+1D00, U+1D1B, U+1D62-1D65, U+1E00-1E9B, U+1E9E, U+2020, U+20A1, U+20A7-20A9, U+20AF, U+20B2, U+20B5, U+20B8, U+20BF, U+2C7C, U+2C7F",
    },
  ],
})

const fontInter = localFont({
  src: [
    { path: "../fonts/inter/inter-core-normal.woff2", style: "normal" },
    { path: "../fonts/inter/inter-core-italic.woff2", style: "italic" },
  ],
  weight: "400 600",
  display: "swap",
  declarations: [
    {
      prop: "unicode-range",
      value:
        "U+0000, U+0020-007E, U+00A0-00AC, U+00AE-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+2002, U+2009, U+200B, U+2013-2014, U+2018-201A, U+201C-201E, U+2022, U+2026, U+2032-2033, U+2039-203A, U+2044, U+20AC, U+2122, U+2191, U+2193, U+2212, U+FEFF",
    },
  ],
})

const circularStdExtended = localFont({
  src: [
    {
      path: "../fonts/circular/circular-std-black-extended.woff2",
      style: "normal",
    },
  ],
  weight: "900",
  display: "swap",
  preload: false,
  adjustFontFallback: false,
  declarations: [
    {
      prop: "unicode-range",
      value:
        "U+00A8, U+00AF, U+00B4-00B5, U+00B8, U+00BC-00BE, U+02C6-02C7, U+02C9, U+02D8-02DD, U+0394, U+03A9, U+03BC, U+03C0, U+2007-2008, U+2042, U+2044, U+2051, U+2126, U+2160-2169, U+216C-216F, U+2190-2193, U+2196-2199, U+21A9, U+21B0-21B4, U+21C6, U+2202, U+220F, U+2219, U+22C5, U+25A0-25A1, U+25B2-25B3, U+25CA, U+2713, U+2715, U+E000-E002",
    },
  ],
})

const circularStd = localFont({
  src: [
    {
      path: "../fonts/circular/circular-std-black-core.woff2",
      style: "normal",
    },
  ],
  weight: "900",
  display: "swap",
  declarations: [
    {
      prop: "unicode-range",
      value:
        "U+0020-007E, U+00A0-00A7, U+00A9-00AE, U+00B0-00B3, U+00B6-00B7, U+00B9-00BB, U+00BF-00FF, U+0131, U+0141-0142, U+0152-0153, U+0160-0161, U+0178, U+017D-017E, U+0192, U+200B, U+2013-2014, U+2018-201A, U+201C-201E, U+2020-2022, U+2026, U+2030, U+2039-203A, U+2070, U+2074-2079, U+2080-2089, U+20AC, U+2113, U+2122, U+2206, U+2211-2212, U+2215, U+221A, U+221E, U+222B, U+2248, U+2260, U+2264-2265, U+24C5, U+25CB, U+25CF, U+262E, U+2780-2788, U+FB00-FB04, U+FEFF",
    },
  ],
})

// The core goes last so its metric-adjusted fallback only catches characters no file covers
export const interFontFamily = [
  fontInterCyrillicExt,
  fontInterCyrillic,
  fontInterGreekExt,
  fontInterGreek,
  fontInterVietnamese,
  fontInterLatinExtRare,
  fontInterLatinExt,
  fontInter,
]
  .map((font) => font.style.fontFamily)
  .join(", ")

// Characters Circular lacks fall to its Arial fallback, as before it was subset
export const circularFontFamily = [circularStdExtended, circularStd]
  .map((font) => font.style.fontFamily)
  .join(", ")

// Downloaded at idle by `Fonts`, so a page that later needs them does not swap fonts
export const precachedFontFamilies = [
  fontInterLatinExt,
  circularStdExtended,
].map((font) => font.style.fontFamily)
